import {
  FormPreviewMode,
  FormView,
  ISubscriptionForm,
  SubscriptionFormReceiver,
} from "web/types/Subscription";

interface IFormStatus {
  isCompleted: boolean;
  isEditable: boolean;
}

interface IGetFormStatus {
  form: ISubscriptionForm;
  templateView: FormView;
  allowChangingPersonalData: boolean;
  wayChooseOthersInActiveForm: SubscriptionFormReceiver;
  doesFormNeedUpdate: boolean;
}

export default ({
  form,
  templateView,
  allowChangingPersonalData = true,
  wayChooseOthersInActiveForm,
  doesFormNeedUpdate = false,
}: IGetFormStatus): IFormStatus => {
  const status = {
    isEditable: false,
    // @TODO change "isCompleted" status name to something more meaningful and appropriate
    isCompleted: false,
    previewMode: FormPreviewMode.EDITABLE_PREVIEW,
  };
  // completed - defines whether the form has been ever filled in at 2nd step of configurator
  // receiver - defines for whom the form is created - employee or additional person
  // submitted - defines whether user went through whole configurator process with filled form
  const { completed, receiver, submitted, ignoreValidate } = form;

  // Forms on My Benefits page are always submitted - no other way
  const isSubmitted =
    templateView === FormView.MY_BENEFITS || ignoreValidate
      ? true
      : !!submitted;

  if (receiver === SubscriptionFormReceiver.EMPLOYEE) {
    status.isCompleted = isSubmitted && !doesFormNeedUpdate;
    status.previewMode =
      templateView === FormView.MY_BENEFITS
        ? FormPreviewMode.EDITABLE_PREVIEW
        : FormPreviewMode.BUTTONS;
  } else if (receiver === SubscriptionFormReceiver.OTHERS) {
    // jeżeli osoba dodatkowa sama wypełnia swoje dane - traktujemy stan completed jako podanie jej maila przez pracownika
    status.isCompleted =
      wayChooseOthersInActiveForm === SubscriptionFormReceiver.OTHERS
        ? isSubmitted
        : completed && !doesFormNeedUpdate;
    status.previewMode = FormPreviewMode.EDITABLE_PREVIEW;
  }

  status.isEditable = isSubmitted
    ? status.isCompleted && allowChangingPersonalData
    : status.isCompleted;

  return status;
};
